angular
	.module 'App.Repository'
	.factory 'VoucherRepository',
		[
			'$rootScope', '$q', 'API_ENDPOINT', 'BaseRepository', 'MessageTerminal', 'BACKEND_GIFTCARD_PROVIDER_ENTITY_TYPE',
			($rootScope, $q, API_ENDPOINT, BaseRepository, MessageTerminal, BACKEND_GIFTCARD_PROVIDER_ENTITY_TYPE) ->
				class VoucherRepository extends BaseRepository
					@resource = '/giftcard_provider'
					@isRestricted = true

					constructor: ->
						super arguments...

						@voucherProviders = {}

						MessageTerminal.on($rootScope, MessageTerminal.events.LOGOUT, => @voucherProviders = {})

					listTransactions: (id) ->
						return @find "#{id}/transactions"
							.then (response) =>
								return response.data
							.catch (response) =>
								console.error(response)

								return []

					findVoucherProvider: ->
						entityType = BACKEND_GIFTCARD_PROVIDER_ENTITY_TYPE.WM_VOUCHER_PROVIDER_MODEL

						if angular.isUndefined @voucherProviders[entityType]
							query = @createQuery()
							query.criteria 'entity_type', '=', entityType

							return @findByQuery(query).then (response) => @voucherProviders[entityType] = response.data[0]
						else
							return $q.when @voucherProviders[entityType]

					findVouchersList: (query) ->
						@findVoucherProvider().then (provider) =>
							query.sortBy 'create_time', 'DESC'

							return @findByQuery query, "/#{provider.id}/list"

					findVoucher: (id) ->
						@findVoucherProvider().then (provider) =>
							@findById(provider.id + '/' + id)

					sendEmail: (email, id, updateWithNewValue = true) ->
						@findVoucherProvider().then (provider) =>
							@post "#{provider.id}/#{id}/send", {save: updateWithNewValue, email: email}

					setStatus: (id, status) ->
						@findVoucherProvider().then (provider) =>
							@post "#{provider.id}/#{id}/status", {status: status}

					# Lists gift cards bought/used by a customer, across all giftcard providers
					findGiftcardsForCustomer: (customerId, query) ->
						@findByQuery query, "/customer/#{customerId}/list", '/giftcards'

				return new VoucherRepository
		]
